var render, staticRenderFns
import script from "./TransitionExpand.vue?vue&type=script&lang=js"
export * from "./TransitionExpand.vue?vue&type=script&lang=js"
import style0 from "./TransitionExpand.vue?vue&type=style&index=0&id=dfeaaa5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfeaaa5a",
  null
  
)

export default component.exports